import m from "../../geodata/es2015/palestineHigh";
window.am4geodata_palestineHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/palestineHigh.js
// module id = null
// module chunks = 